<template>
  <v-container fill-height fluid pa-0>
    <v-layout fill-height>
      <v-flex lg8>
        <v-layout align-center justify-center>
          <success-view
            v-if="success"
            title="Contraseña actualizada"
            message="Puede volver al inicio e ingresar nuevamente a la plataforma con sus datos actualizados"
            redirect="/login"
          />
          <v-card v-else width="500" class="elevation-12">
            <v-card-text>
              <v-container fluid>
                <v-layout class="mb-1">
                  <v-flex xs12 class="f2-5em text-xs-center text-light k-orange-linear-text">
                    Cambio de contraseña
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      v-model="form.email"
                      v-validate="'required|email'"
                      data-vv-scope="recoverPassword"
                      data-vv-name="email"
                      :error-messages="errors.collect('recoverPassword.email')"
                      label="Email"
                      color="black"
                      type="text">
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      v-model="form.temporal_password"
                      v-validate="'required'"
                      data-vv-scope="recoverPassword"
                      data-vv-name="temporal_password"
                      data-vv-as="contraseña temporal"
                      :error-messages="errors.collect('recoverPassword.temporal_password')"
                      label="Contraseña temporal"
                      color="black"
                      type="password">
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-form @submit.prevent @keyup.native.enter="recoverPassword()">
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        ref="password"
                        v-model="form.password"
                        v-validate="'required|min:10|field-capital-letter|field-lowercase-letter|field-alphabetic-characters|field-two-numbers|field-special-chars'"
                        data-vv-scope="recoverPassword"
                        data-vv-name="password"
                        data-vv-as="nueva contraseña"
                        :error-messages="errors.collect('recoverPassword.password')"
                        label="Nueva contraseña"
                        color="black"
                        type="password">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        v-model="form.confirm_password"
                        v-validate="'confirmed:password|required|min:10|field-capital-letter|field-lowercase-letter|field-alphabetic-characters|field-two-numbers|field-special-chars'"
                        data-vv-scope="recoverPassword"
                        data-vv-name="confirm_password"
                        data-vv-as="confirmar contraseña"
                        :error-messages="errors.collect('recoverPassword.confirm_password')"
                        label="Confirmar contraseña"
                        color="black"
                        type="password">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row class="mb-3 mt-3">
                    <v-flex xs12>
                      <v-btn
                        class="k-orange-linear white--text"
                        block
                        large
                        @click="recoverPassword"
                        :disabled="loading || errors.any('recoverPassword')"
                      >
                        GUARDAR CAMBIOS
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-flex>
      <v-flex hidden-md-and-down lg4 xl4 class="k-orange-linear-d">
        <sidebar>
          <img slot="centered" :src="require('@/assets/img/colektia.png')" width="80%" alt="Colektia">
        </sidebar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Sidebar from '@/components/login/Sidebar';
import SuccessView from '@/components/global/SuccessView';

export default {
  inject: ['$validator'],
  components: {
    Sidebar,
    SuccessView,
  },
  beforeRouteEnter(to, from, next) {
    localStorage.clear();
    next();
  },
  mounted() {
    this.$validator.reset();
    this.errors.clear();
  },
  data() {
    return {
      success: false,
      loading: false,
      form: {
        email: '',
        temporal_password: '',
        password: '',
        confirm_password: '',
      },
    };
  },
  computed: {
    isValidPassword() {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=(.*[a-zA-Z]){6,})(?=(.*\d){2,})(?=(.*[!@#$%^&*()]){2,}).{10,}$/;
      return regex.test(this.form.password);
    },
  },
  methods: {
    recoverPassword() {
      if (!this.isValidPassword) {
        this.errors.add({
          field: 'recoverPassword.password',
          msg: 'Contraseña inválida, verifique que la contraseña cumpla con las politicas de seguridad.',
        });
        return;
      }
      if (this.form.temporal_password === this.form.password) {
        this.errors.add({
          field: 'recoverPassword.password',
          msg: 'Contraseña inválida, verifique que la contraseña nueva no coincida con la temporal.',
        });
        return;
      }
      this.$validator.validateAll('recoverPassword')
        .then((validation) => {
          if (validation) {
            this.loading = true;
            this.errors.clear();
            this.axios.post('auth/recover_password', this.form)
              .then(() => {
                this.success = true
              })
              .catch((error) => {
                let msg = (((error || {}).response || {}).data || {}).message;
                if (msg) {
                  this.errors.add({
                    field: 'recoverPassword.confirm_password',
                    msg,
                  });
                }
              })
              .finally(() => {
                this.loading = false
              });
          }
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/login/RecoverPassword.vue